import { createJSONStorage } from "zustand/middleware";
import { createStore } from ".";
import { jwtDecode } from "jwt-decode";

export interface AccessProps {
  accessToken: string;
  refreshToken: string;
  expiresAt: number;
  email: string
}

type JwtPayload = {
  exp?: number; // 만료(초, epoch)
  iat?: number;
  sub?: string;
  [k: string]: unknown;
};

const initState = {
  accessToken: "",
  refreshToken: "",
  expiresAt: 0,
  email: ""
};

interface AccessState {
  access: AccessProps;
  payload: JwtPayload | null;
  setAccess: (access: AccessProps) => void;
  clearAccess: () => void;
  isAuthenticated: () => boolean;
  setIsRefreshing: (status: boolean) => void;
  isRefreshing: boolean;
  willExpireSoon: (leewaySec?: number) => boolean;
  getAccessToken: () => string | null;
}

export const useLoginStore = createStore<AccessState>(
  (set, get) => ({
    access: initState,
    payload: null,
    isRefreshing: false,
    setAccess: (partial) => {
      const next = { ...get().access, ...partial };
      let payload: JwtPayload | null = null;

      // accessToken이 존재하면 디코딩 시도
      try {
        if (next.accessToken) payload = jwtDecode<JwtPayload>(next.accessToken);
      } catch {
        payload = null;
      }

      set({ access: next, payload });
    },

    clearAccess: () => set({ access: initState, payload: null }),

    isAuthenticated: () => {
      const { accessToken } = get().access;
      const { payload } = get();
      if (!accessToken || !payload?.exp) return false;
      const now = Math.floor(Date.now() / 1000);
      return now < payload.exp;
    },

    willExpireSoon: (leewaySec = 30) => {
      const { payload } = get();
      if (!payload?.exp) return true; // exp 없으면 만료 취급
      const now = Math.floor(Date.now() / 1000);
      return now >= payload.exp - leewaySec;
    },
    setIsRefreshing: (status) => set({ isRefreshing: status }),
    getAccessToken: () => {
      const t = get().access.accessToken;
      return t && t.length > 0 ? t : null;
    },
  }),
  {
    name: "loginInfo",
    storage: createJSONStorage(() => localStorage),
  }
);
